import { createTheme, responsiveFontSizes } from "@mui/material";
import shadows from "@mui/material/styles/shadows";

let DefaultTheme = createTheme({
  palette: {
    primary: {
      // main: '#F8CE6F',
      main: "#feca60"
    },
    secondary: {
      main: '#1c9d85',
      dark: "#198d77",
      light: "#fffcf6"
    },
    background: {
      // default: "#000000"
    },
  },
  components: {
    MuiContainer: {
      styleOverrides: {
        root: {
          borderRadius: 16
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 16,
        }
      },
      variants: [
        {
          props: { size: 'small' },
          style: {
            padding: "12px 24px"
          },
        },
        {
          props: { size: 'medium' },
          style: {
            padding: "14px 28px"
          },
        },
        {
          props: { size: 'large' },
          style: {
            padding: "16px 32px"
          },
        },
      ]
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: 16
        }
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: "#f0f0f0"
        }
      }
    }
  },
  shape: {
    borderRadius: 16
  },
  shadows: [
    "none",
    "rgba(9, 30, 66, 0.25) 0px 4px 6px -5px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px",
    "rgba(9, 30, 66, 0.25) 0px 1px 1px, rgba(9, 30, 66, 0.13) 0px 0px 1px 1px",
    "rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px",
    "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgb(209, 213, 219) 0px 0px 0px 1px inset",
    "0 1px 5px rgb(0 0 0 / 15%)",
    "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgb(209, 213, 219) 0px 0px 0px 1px inset",
    "rgba(9, 30, 66, 0.25) 0px 4px 6px -5px, #F8CE6F 0px 0px 0px 1px",
    "rgba(0, 0, 0, 0.05) 0px 0px 0px 1px",
    "rgba(0, 0, 0, 0.05) 0px 0px 0px 1.25px",
    "#F8CE6F 0px 0px 0px 1px",
    "#1c9d85 0px 0px 0px 1px",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ],
  breakpoints: {
    values: {
      xs: 0,
      sm: 768,
      md: 1024,
      lg: 1440,
      xl: 1600,
    },
  },
});

DefaultTheme = responsiveFontSizes(DefaultTheme);

export default DefaultTheme;